import type { FaireProductEntity } from "../../entity_types/product";

export const p_7x5g8mswgz: FaireProductEntity = {
  token: "p_7x5g8mswgz",
  type: "product",
  name: "Liquid Chlorophyll",
  brandToken: "b_a3tpqf5bwb",
  brandName: "Double Wood Supplements",
  imageUrl:
    "https://cdn.faire.com/fastly/59b458020fdd29411353870aa122ba82c5dd43e3f1a9d80d87cd99db60e79391.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a7bdffe1f4bcbb582ecde22b20d67ec5229f15c6bc0d1651eef9cf55eea1fee.jpeg",
    "https://cdn.faire.com/fastly/4a704dc46528d5f92423830ec9dd4a92fac7179fa00c6367047dd3157df6eefe.jpeg",
    "https://cdn.faire.com/fastly/06cc34c4ada6dd08d1eef24f80e0bb2ee93179c52e70d797a01cce2306da8c6b.jpeg",
    "https://cdn.faire.com/fastly/b683a44069455478b6ed751e3c40a6b1c3192beffd7e9b09ff9beb1e60098fa5.jpeg",
  ],
  priceDollars: 10.28,
  description:
    "Chlorophyll is well known as the pigment in plants which gives them their green color and plays a key role in the photosynthesis process where plants create energy from sunlight. Less known is that chlorophyll has potent antioxidant properties and contains numerous vitamins and minerals. These properties make it an effective supplement for a variety of health benefits including supporting healthy digestion, immune function, detoxification, as well as having some benefit as a weight loss supplement.\n\nDouble Wood’s Liquid Chlorophyll supplement is naturally extracted from Mulberry Leaves and uses an MCT oil base for improved absorption. Each bottle contains 120 50 mg servings.",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:39.907Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
